export default "__VITE_ASSET__EkDsx5JV__"